import { lazy, Suspense } from "react";

import { Loader } from "./components/Loader";

import ErrorBoundary from "./components/ErrorBoundary";

const CryptoZombie = () => {
	const Component = lazy(() => import(`./containers/Zombies`));
	return (
		<ErrorBoundary>
			<Suspense fallback={<Loader />}>
				<Component />
			</Suspense>
		</ErrorBoundary>
	);
};

const CryptoZombieFeed = () => {
	const Component = lazy(() => import(`./containers/Zombies/feed`));
	return (
		<ErrorBoundary>
			<Suspense fallback={<Loader />}>
				<Component />
			</Suspense>
		</ErrorBoundary>
	);
};

const CryptoZombieBattle = () => {
	const Component = lazy(() => import(`./containers/Zombies/battle`));
	return (
		<ErrorBoundary>
			<Suspense fallback={<Loader />}>
				<Component />
			</Suspense>
		</ErrorBoundary>
	);
};

const Wallet = () => {
	const Component = lazy(() => import(`./containers/Wallet`));
	return (
		<ErrorBoundary>
			<Suspense fallback={<Loader />}>
				<Component />
			</Suspense>
		</ErrorBoundary>
	);
};

const routes = [
	// games
	//// zombie
	{
		path: "/",
		name: "wallet",
		component: Wallet,
	},
	{
		path: "/wallet",
		name: "wallet",
		component: Wallet,
	},
	{
		path: "/games/zombie",
		name: "zombie games",
		component: CryptoZombie,
	},
	{
		path: "/games/zombie/feed/:zombie_id",
		name: "zombie games feed",
		component: CryptoZombieFeed,
	},
	{
		path: "/games/zombie/battle/:zombie_id",
		name: "zombie games battle",
		component: CryptoZombieBattle,
	},
];

export default routes;
